import gql from 'graphql-tag';
import { practiceFull } from '../../__fixtures__/practiceFull';
import { graphMutation, graphQuery } from '@services/commService';

export const createEntity = async (info, components = [], courseID) => {
  const { name, texts: { description }, isDefault } = info;
  const children = components
    .filter((child) => !child.payload.mapToField)
    .map(({ payload, type }) => ({ type, id: payload.id }));

  const mutation = gql`
  mutation($children: [entityRelationInputType]!) {
    createEntityCourse(
      name:"${name}",
      texts: {description: """${description}"""},
      isDefault: ${isDefault || false},
      children:$children
       ){
        id
      }
    }
  `;
  return await graphMutation(mutation, { children });
};

export const editEntity = async (info, components = [], courseID) => {
  const { name, texts: { description }, isDefault } = info;
  const children = components
    .filter((child) => !child.payload.mapToField)
    .map(({ payload, type }) => ({ type, id: payload.id }));

  const mutation = gql`
  mutation($children: [entityRelationInputType]!) {
    modifyCourse(
      id:"${info.id}",
      name:"${name}",
      texts: {description: """${description}"""},
      isDefault: ${isDefault || false},
      children:$children
       ){
        id
      }
    }
  `;
  return await graphMutation(mutation, { children });
};

export const deleteEntity = async(id)=>{
  
  const mutation = `mutation{
    deleteCourse(
      id:"${id}"
    ){
      name
    }

  }`
  
  return await graphMutation(mutation,{}, true);
}

export const loadEntity = async (id) => {
  if (process.env.USE_FIXTURES) {
    return { data: { entity: [practiceFull] } };
  }
  const query = `
  {
    entity:entityCourses(id:"${id}",range:[0,1],fullData:true) {
    id
    name
    createdAt
    isDefault
    texts{
      description
    }
    children(full:true){
      type
      payload
    }
  }}
  `;
  return await graphQuery(query, true);
};
